<template>
  <div
    class="p-2 text-black flex flex-row items-center group cursor-pointer leading-none hover:bg-gray-100 duration-300 transition gap-2"
    @click="clicked"
  >
    <i
      :class="{
        'text-white': !active,
        'text-black': active,
      }"
      class="fas fa-check"
    />
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  emits: ['click'],
  setup(_, context) {
    return {
      clicked() {
        context.emit('click');
      }
    };
  }
};
</script>
